var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import styled from 'styled-components';
import { Header4 } from './typography';
import { CardContext } from './card';

var headerColor = function headerColor(p) {
  if (p.brand) {
    if (p.invert) {
      return p.theme.colorLevel(p.theme[p.brand], 5);
    } else {
      return p.theme.white;
    }
  } else {
    return p.theme.textPrimary;
  }
};

var headerBackground = function headerBackground(p) {
  if (p.theme.themeName === 'greenlight') {
    if (p.brand) {
      if (p.invert) {
        return p.theme.colorLevel(p.theme[p.brand], -5);
      } else {
        return p.theme[p.brand];
      }
    } else {
      return p.theme.level5;
    }
  } else {
    if (p.brand) {
      if (p.invert) {
        return p.theme.colorLevel(p.theme[p.brand], -5);
      } else {
        return p.theme[p.brand];
      }
    } else {
      return p.theme.level1;
    }
  }
};

var Header = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  border-radius: ", "\n    ", " 0 0;\n  color: ", ";\n  margin-bottom: 0;\n  padding: ", " ", ";\n\n  & > h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    color: inherit;\n    margin: 0;\n  }\n\n  &.card-header-disabled {\n    filter: blur(5px);\n    -webkit-filter: blur(5px);\n    -moz-filter: blur(5px);\n    -o-filter: blur(5px);\n    -ms-filter: blur(5px);\n  }\n"], ["\n  background-color: ", ";\n  border-radius: ", "\n    ", " 0 0;\n  color: ", ";\n  margin-bottom: 0;\n  padding: ", " ", ";\n\n  & > h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    color: inherit;\n    margin: 0;\n  }\n\n  &.card-header-disabled {\n    filter: blur(5px);\n    -webkit-filter: blur(5px);\n    -moz-filter: blur(5px);\n    -o-filter: blur(5px);\n    -ms-filter: blur(5px);\n  }\n"])), headerBackground, function (p) {
  return p.brand && !p.invert ? '13px' : p.theme.cardBorderRadius;
}, function (p) {
  return p.brand && !p.invert ? '13px' : p.theme.cardBorderRadius;
}, function (p) {
  return headerColor(p);
}, function (p) {
  return p.theme.cardSpacerY;
}, function (p) {
  return p.theme.cardSpacerX;
});

var CardHeader = function CardHeader(_a) {
  var children = _a.children,
      className = _a.className,
      _b = _a.disableChildren,
      disableChildren = _b === void 0 ? false : _b,
      props = __rest(_a, ["children", "className", "disableChildren"]);

  var classes = className ? className + " card-header" : 'card-header';

  if (disableChildren) {
    classes += ' card-header-disabled';
  }

  return React.createElement(CardContext.Consumer, null, function (context) {
    return React.createElement(Header, Object.assign({
      className: classes
    }, context, props), React.createElement(Header4, null, children));
  });
};

export default CardHeader;
var templateObject_1;